import { useFirebase } from 'components/Firebase/index.js';
import useOrgId from './useOrgId.js';
import { useQuery } from 'react-query';

const useVodSettings = (options = {}) => {
  const firebase = useFirebase();
  const orgId = useOrgId();
  const { enabled, ...queryOptions } = options;

  return useQuery({
    ...queryOptions,
    queryKey: ['vod-settings', orgId],
    queryFn: async () => {
      const agent = await firebase.getAgent();
      const { body } = await agent.get(`/o/${orgId}/settings/vod`);
      return body;
    },
    enabled: !!orgId && enabled !== false,
  });
};

export default useVodSettings;
